import UserAvatar from "./UserAvatar.png";

export * from "./LLoydsBankLogo";

export const images = {
  userAvatar: UserAvatar,
};
